import React from "react";
import { MOBILE_WIDTH } from "../../config";
import Header from "../Header";
import Sidebar from "../Sidebar";
import * as C from "./styles";


type Props = {
  children: JSX.Element | JSX.Element[] | boolean | string | undefined;
};

export default function DashboardTemplate({ children }: Props) {
  const [isSidebarOpened, setIsSidebarOpened] = React.useState<boolean>(false);

  window.addEventListener("resize", (e) => {
    if (window.innerWidth > parseInt(MOBILE_WIDTH)) {
      setIsSidebarOpened(false);
    }
  });

  return (
    <C.MainContainer>
      <Sidebar
        setSidebarOpened={setIsSidebarOpened}
        isOpened={isSidebarOpened}
      />
      <C.RightContainer>
        <Header
          setSidebarOpened={setIsSidebarOpened}
          sidebarOpened={isSidebarOpened}
        />
        <C.ContentContainer className="content-header">
          {children}
        </C.ContentContainer>
      </C.RightContainer>
    </C.MainContainer>
  );
}
